module.exports = __webpack_public_path__ + "img/21.d8d0f437.png";